import axios from "axios"
import { startLoading, stopLoading } from "./loaderBus"

// Registers request/response interceptors that drive the global loader
// overlay for a given axios instance. Exported so any other axios.create()
// instance in the app (e.g. helpers/api_helper.js) can opt in too.
export function attachLoaderInterceptors(instance) {
  instance.interceptors.request.use(
    config => {
      // Background polling (notification badge, chat refresh, campaign
      // status) sets `skipLoader: true` so it doesn't flash this overlay
      // over the whole app every few seconds - only user-initiated loads
      // (navigation, button clicks) should block the screen.
      if (!config.skipLoader) startLoading()
      return config
    },
    error => {
      stopLoading()
      return Promise.reject(error)
    },
  )
  instance.interceptors.response.use(
    response => {
      if (!response.config?.skipLoader) stopLoading()
      return response
    },
    error => {
      if (!error.config?.skipLoader) stopLoading()
      return Promise.reject(error)
    },
  )
}

// Most pages in this app `import axios from "axios"` directly rather than
// going through a shared instance, so attach to the default export - it's
// the same singleton module every one of those imports resolves to.
attachLoaderInterceptors(axios)
